'use strict';

var App = require('app');
var Consts = require('consts');
var i18n = require('utils/i18n');

var API = {
    // gets the filter options (texts, lists)
    getFilterLabels: function (options) {
        var defer = $.Deferred();
        App.ajax({
            method: 'GET',
            url: '/api/v1/me/search_labels',
            success: function (filterOptions) {
                defer.resolve(filterOptions);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getFilterValueContent: function (field) {
        var defer = $.Deferred();
        App.ajax({
            data: { field: field },
            method: 'GET',
            url: '/api/v1/values-content',
            success: function (content) {
                defer.resolve(content);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('filter:labels', function (options) {
    return API.getFilterLabels(options);
});

App.reqres.setHandler('values:content', function (field) {
    return API.getFilterValueContent(field);
});
